import { apiSlice } from '../../api/apiSlice';

export const setApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    lessonExist: builder.mutation({
      query: (option) => ({
        url: `Set/Course/${option.courseId}/LessonExist`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getLessonSets: builder.mutation({
      query: (option) => ({
        url: `Set/Course/${option.courseId}/Lessons`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getSetById: builder.mutation({
      query: (option) => ({
        url: `Set/${option.setId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
  })
});

export const {
  useLessonExistMutation,
  useGetLessonSetsMutation,
  useGetSetByIdMutation
} = setApi;